/**
 * ServiceTopologyView — Dispatcher that renders the proper per-type topology
 * editor / viewer based on the Service.service_type.
 */
import React from 'react';
import VpnTopologyView      from './topology/VpnTopologyView';
import DatabaseTopologyView from './topology/DatabaseTopologyView';
import RdsTopologyView      from './topology/RdsTopologyView';

export const TOPOLOGY_SERVICE_TYPES = new Set([
  'vpn', 'database', 'rds_farm',
]);

export default function ServiceTopologyView({ serviceType, serviceId, companyId, serviceName }) {
  if (!serviceId) return null;
  switch (serviceType) {
    case 'vpn':
      return <VpnTopologyView      serviceId={serviceId} companyId={companyId} serviceName={serviceName} />;
    case 'database':
      return <DatabaseTopologyView serviceId={serviceId} companyId={companyId} serviceName={serviceName} />;
    case 'rds_farm':
      return <RdsTopologyView      serviceId={serviceId} companyId={companyId} serviceName={serviceName} />;
    default:
      return (
        <div className="dv-tab-pane" style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>
          No hay vista de topología disponible para este tipo de servicio.
        </div>
      );
  }
}
